import { SUGGESTION_TYPES } from '@trustero/trustero-api-web/lib/recommend/recommend_pb'
import { SUGGESTIONS } from './ControlsShowItemGuidance.constants'

export const getSuggestionType = (type: SUGGESTION_TYPES): SUGGESTIONS => {
  switch (type) {
    case 1:
      return SUGGESTIONS.SUGGESTED_EVIDENCE
    case 2:
      return SUGGESTIONS.SUGGESTED_TESTS
    case 3:
      return SUGGESTIONS.TAILORED_GUIDANCE
    case 4:
      return SUGGESTIONS.GENERAL_GUIDANCE
    default:
      return SUGGESTIONS.UNKNOWN
  }
}

export const getNotesCopy = (
  isUpdating: boolean,
  isCustom: boolean,
): string => {
  return isCustom
    ? 'Manually updated'
    : isUpdating
    ? 'Loading and will be available in under a minute...'
    : 'Trustero provided - based on expert opinion and real audits'
}
